import React, { memo } from 'react';
const bonuses = [{
  num: '01',
  emoji: '💥',
  title: '100 WOD Pronti',
  desc: 'Workout functional già pronti da usare.'
}, {
  num: '02',
  emoji: '🔥',
  title: 'Warm Up Express',
  desc: 'Activation flow e mobility già pronti.'
}, {
  num: '03',
  emoji: '🧘',
  title: 'Mobility Flow',
  desc: 'Routine recovery e posture premium.'
}, {
  num: '04',
  emoji: '📱',
  title: 'Social Content Kit',
  desc: 'Template Instagram e branding fitness.'
}, {
  num: '05',
  emoji: '📊',
  title: 'Client Tracker Pro',
  desc: 'Sistema professionale di gestione clienti.'
}, {
  num: '06',
  emoji: '🎵',
  title: 'Playlist & Coach Energy System',
  desc: 'Energia, atmosfera e classi memorabili.'
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4 relative overflow-hidden" data-id="element-16">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/8 rounded-full blur-[120px] pointer-events-none" data-id="element-17"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-18">
        <div className="text-center mb-14" data-id="element-19">
          <span className="inline-flex items-center gap-2 bg-primary/15 border border-primary/40 text-primary font-bold uppercase tracking-[0.2em] text-xs sm:text-sm px-4 py-1.5 rounded-sm mb-5" data-id="element-20">
            🎁 Bonus Esclusivi
          </span>
          <h2 className="font-display text-3xl sm:text-5xl font-bold text-white mb-3 tracking-tight uppercase" data-id="element-21">
            🔥 6 Bonus Esclusivi
          </h2>
          <p className="text-text-sec text-lg sm:text-xl font-medium mb-2" data-id="element-22">
            (Valore €97 — GRATIS Oggi)
          </p>
          <p className="text-badge-red font-display font-bold text-xl sm:text-2xl line-through opacity-90 tracking-tight" data-id="element-23">
            Valore totale: €97
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-24">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-sm border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-all hover:-translate-y-1 hover:border-primary/40 group relative overflow-hidden" data-id="element-25">
              <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary/0 group-hover:bg-primary transition-colors" data-id="element-26"></div>

              <div className="flex items-center gap-4 flex-shrink-0" data-id="element-27">
                <span className="font-display text-primary/20 font-bold text-4xl sm:text-5xl tracking-tighter" data-id="element-28">
                  {bonus.num}
                </span>
                <div className="w-14 h-14 rounded-sm bg-primary/10 border border-primary/30 flex items-center justify-center text-2xl" data-id="element-29">
                  {bonus.emoji}
                </div>
              </div>

              <div className="flex-1 min-w-0" data-id="element-30">
                <p className="text-primary text-xs font-bold uppercase tracking-[0.2em] mb-1" data-id="element-31">
                  BONUS {bonus.num}
                </p>
                <h3 className="text-white font-display font-bold text-lg sm:text-xl mb-1 uppercase tracking-wide" data-id="element-32">
                  {bonus.title}
                </h3>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-33">
                  {bonus.desc}
                </p>
              </div>

              <span className="bg-cta-green/15 text-check-green border border-check-green/40 px-4 py-2 rounded-sm font-display font-bold text-sm sm:text-base flex-shrink-0 uppercase tracking-wider" data-id="element-34">
                GRATIS
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}